import React, { useState, useEffect, useCallback } from 'react'
import { CommunityLeadsPersonalValidation } from '../../Validations'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Loader from '../../../../../presentationals/Loader/Loader.component'
import PiePage from '../../CommonComponents/PiePage.component'
// import Routes from '../../../../Layout/Routes'
import { CommunityLeadSaveUserApi, CommunityLeadGetUserApi, CommunityLeadGetUserLoanApi, getNameOnPanApi } from './AddLeadActionCreator'
import InputField from '../../CommonComponents/InputMUI'
// import DatePicker from '../../../common/DatePickerMUI'
import { TextField } from '@mui/material'
import SelectField from '../../CommonComponents/SelectMUI'
import {
  employmentTypeArr, secureLoanTypeArr, unsecureLoanTypeArr, loanSegmentArr, borrowingTypeArr
} from '../../CommonUtils'
import moment from 'moment'
import { InputLabel } from '@mui/material'
import { WEBSITE } from '../../CommonUtils'
import CustomPopup from '../../Popups/CustomPopup'

const msg = "Thank You!!!   We have sent a loan completion link to the corresponding e-mail id. Do you wish to complete the loan?"

const communityId = window.sessionStorage.getItem("communityId") !== null ? window.sessionStorage.getItem("communityId") : ''

const AddCommunityLeadPersonal = ({Pagedata,handlePage,handleTab}) => {
  const [objectData, setObjectData] = useState({})

  // const [objectData, setObjectData] = useState({ name: '', emailId: "", mobileNo: "", dob: new Date(), panNo: "", nameOnPan: "", communityId: communityId, aadharNo: '', nameOnAadhaar: '', loanSegment: '', loanType: '', borrowingType: '', employmentType: '',sourceOfIncome:'' })
  const [message, setMessage] = useState({})
  const [loaderState, setLoaderState] = useState(false)
  const [customLoaderState, setCustomLoaderState] = useState(false)
  const navigate = useNavigate();
  const location = useLocation();
  const [responseMsg, setResponseMsg] = useState('')
  const [enterLoanType, setEnterLoanType] = useState(false)
  const [dataToSet, setDataToSet] = useState(undefined)
  const [, updateState] = useState();

  const forceUpdate = React.useCallback(() => updateState({}), []);

  useEffect(() => {
    console.log(Pagedata, "  statestate");
    if (Pagedata !== null && Pagedata.rowData !== undefined) {
      // console.log(objectData)
      let changeObjectData = Object.assign({}, objectData)
      changeObjectData.communityId = communityId
      if (Pagedata.rowData.userId !== undefined) {
        changeObjectData.userId = Pagedata.rowData.userId

      }
      // console.log(location.state.rowData.loanId, "loanId");
      if (Pagedata.rowData.loanId !== null && Pagedata.rowData.loanId !== undefined) {
        changeObjectData.loanId = Pagedata.rowData.loanId
        // getLoanDetail(location.state.rowData.loanId)
      }

      setObjectData(changeObjectData)
      getPersonalDetail(Pagedata.rowData.loanId, Pagedata.rowData.userId)
    }
    if (Pagedata && Pagedata ? Pagedata ? Pagedata.communityId : null : null) {
      let changeObjectData = Object.assign({}, objectData)

      changeObjectData.communityId = Pagedata ? Pagedata ? Pagedata.communityId : null : null
      setObjectData(changeObjectData)
      // getPersonalDetail()
    }
    else {
      let changeObjectData = Object.assign({}, objectData)

      changeObjectData.communityId = communityId
      setObjectData(changeObjectData)
    }
    if (window.location.href.includes("/external/add")) {
      let loanId = window.location.href.split('external/add/loan/details/')[1].split('/')[1]
      let userId = window.location.href.split('external/add/loan/details/')[1].split('/')[0]
      getPersonalDetail(loanId, userId)
    }
  }, [])

  const getPersonalDetail = (loanId, userId) => {
    let changeObjectData;
    CommunityLeadGetUserApi(userId,
      callBack => {

        // console.log(callBack, 'callback')
        changeObjectData = { ...callBack, ...objectData }
        CommunityLeadGetUserLoanApi(loanId,
          callBack => {
            changeObjectData = { ...changeObjectData, ...callBack }
            setObjectData(changeObjectData)

          }, error => {

          })
        // setObjectData(changeObjectData)
      }, error => {

      })
  }


  const getLoanDetail = (loanId) => {
    // console.log(loanId, 'loanId')
    CommunityLeadGetUserLoanApi(loanId,
      callBack => {
        let changeObjectData = { ...callBack, ...objectData }
        setObjectData(changeObjectData)
      }, error => {

      })
  }

  const inputChange = (e, type) => {
    // console.log(e)
    let changeObjectData = Object.assign({}, objectData)
    changeObjectData[type] = e
    if (type === 'mobileNo') {
      if (e.length > 10) {
        changeObjectData.mobileNo = e.slice(0, 10)
      }
    }
    if (type === 'aadharNo') {
      if (e.length > 12) {
        changeObjectData.aadharNo = e.slice(0, 12)
      }
    }
    if (type === 'emailId') {
      if (e.length > 100) {
        changeObjectData.emailId = e.slice(0, 100)
      }
    }
   
   

    if (type === 'panNo' && changeObjectData[type].length === 10) {
      const data = {
        id: changeObjectData.userId !== undefined ? changeObjectData.userId : '',
        panNumber: changeObjectData.panNo

      }
      setLoaderState(true)
      getNameOnPanApi(data, callBack => {
        if (callBack.message === 'success') {
          // let changeObjectData = Object.assign({}, objectData)
          changeObjectData[type] = e
          // console.log(callBack.data.result)
          if (callBack && callBack.data && callBack.data['status-code'] === '101') {
            changeObjectData.nameOnPan = callBack.data.result.name
            setLoaderState(false)
          } else {
            changeObjectData.nameOnPan = ''
            changeObjectData.panNo = ''
            setMessage({ field: 'panNo', msg: 'enter correct PAN Number' })

            setLoaderState(false)

          }
          setObjectData(changeObjectData)
        }
      }, error => {

      })
    }
    if (type === 'dob') {
      // changeObjectData[type] = moment(e).format('YYYY-MM-DDThh:mm:ssZ')
      changeObjectData[type] = e;

    }
   

    // if(type==='loanType'&&e==='other'){
    //     changeObjectData[type] = ''
    //     setEnterLoanType(true)
    // }else{
    //     setEnterLoanType(false)

    // }
    setObjectData(changeObjectData)
    setMessage({})
  }
  const apiCallToSaveDta = (data) => {

    setLoaderState(true)
    // console.log(objectData, 'objectDatafirst')
    CommunityLeadSaveUserApi(data,
      callBack => {
        // console.log("location state",location.state)
        // console.log("\callBack", callBack)
        // if (location.state !== null && location.state.rowData !== undefined && location.state.rowData.loanId !== undefined) {
        //     callBack.data.loanId = location.state.rowData.loanId
        //     getLoanDetail(location.state.rowData) 


        // }
        if (callBack.data !== undefined && callBack.data !== null) {
          // console.log("dataToset  ", callBack.data);
          if (!window.location.href.includes("/external")) {
            setCustomLoaderState(true)
            setDataToSet(callBack)
          }
          else {
            setDataToSet(callBack)
            forceUpdate()
            customPopupActionhandler("yes", callBack)
          }
        } else {
          setResponseMsg(callBack.message)
        }
        setLoaderState(false)
      },
      error => {
        setLoaderState(false)
      })
  }


  const saveHandler = (e) => {
    // console.log(objectData, 'objectDatafirst')
    if (e === 'save') {
      let validationMsg = CommunityLeadsPersonalValidation(objectData)
      // console.log(validationMsg, 'validationMsg')

      if (validationMsg.status) {
        if (objectData.loanType === 'other') {
          let changeData = Object.assign({}, objectData)
          changeData.loanType = objectData.enterloanType

          setObjectData(changeData)
          apiCallToSaveDta(changeData)
        } else {
          apiCallToSaveDta(objectData)
        }
        setMessage(validationMsg)



      } else {
        setMessage(validationMsg)
      }
    } else if (e === 'close') {
      handlePage("","list")
      // if (!window.location.href.includes('/external')) {
      //   if (location.state ? location.state.communityId : null) {
      //     console.log(location.state);
      //     let data = location.state && location.state.rowData ? location.state.rowData : {}
      //     data.communityId = location.state ? location.state.communityId : null
      //     if (location.state.redirectTo)
      //       navigate(Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE, { state: { rowData: data, page: 'communityLeads', redirectTo: location.state.redirectTo } })
      //     else
      //       navigate(Routes.SUPER_ADMIN_COMMUNITY_DETAIL_PAGE, { state: { rowData: data, page: 'communityLeads' } })
      //   }
      //   else if (location.state ? location.state ? location.state.qrId : null : null) {
      //     let data = location.state && location.state.rowData ? location.state.rowData : {}
      //     data.qrId = location.state ? location.state ? location.state.qrId : null : null
      //     navigate(Routes.SUPER_ADMIN_QR_DETAILS, { state: { rowData: data, page: 'leads' } })
      //   }
      //   else if (window.location.href.includes('admin')) {
      //     navigate(Routes.SUPER_ADMIN_ALL_LEADS)
      //   } else {
      //     navigate(Routes.COMMUNITY_ALL_LEADS)
      //   }
      // }
    }
  }

  const customPopupActionhandler = (e, data) => {
    // console.log(dataToSet ? "not  und" : "enddd", "csffch scjkkj kjsfk");
    // console.log(dataToSet, "dataaaaaa");

    if (e === "yes") {
      if (!window.location.href.includes('/external')) {
        const obj ={
          rowData: dataToSet ? dataToSet.data : data.data,
          communityId: Pagedata ? Pagedata ? Pagedata.communityId : null : null,
          qrId: Pagedata ? Pagedata ? Pagedata.qrId : null : null
        }
        if (objectData.sourceOfIncome === 'businessprofessionalincome') {
          // navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_BUSINESS : Routes.COMMUNITY_ADD_LEAD_BUSINESS, {
          //   state: {
          //     rowData: dataToSet ? dataToSet.data : data.data,
          //     communityId: location.state ? location.state ? location.state.communityId : null : null,
          //     qrId: location.state ? location.state ? location.state.qrId : null : null
          //   }
          // })
          handleTab("adminAddLeadBusiness",obj)
        } else if (objectData.sourceOfIncome === 'salary') {
          // navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_SALARIED : Routes.COMMUNITY_ADD_LEAD_SALARIED,
          //   { state: { rowData: dataToSet ? dataToSet.data : data.data, communityId: location.state ? location.state ? location.state.communityId : null : null, qrId: location.state ? location.state ? location.state.qrId : null : null } })
          handleTab("addLeadSalariedDetails",obj)
        } else {
          handleTab("addLeadProperty",obj)
          // navigate(window.location.href.includes('admin') ? Routes.ADMIN_ADD_LEAD_PROPERTY : Routes.COMMUNITY_ADD_LEAD_PROPERTY,
          //   { state: { rowData: dataToSet ? dataToSet.data : data.data, communityId: location.state ? location.state ? location.state.communityId : null : null, qrId: location.state ? location.state ? location.state.qrId : null : null } })
        }
      }
     
    } else {
      handlePage("","list")
      setCustomLoaderState(false)
      // if (window.location.href.includes('admin')) {
      //   navigate(Routes.SUPER_ADMIN_ALL_LEADS)
      // } else {
      //   navigate(Routes.COMMUNITY_ALL_LEADS)
      // }
    }
  }

  return (
    <div className='container hoverNone card ' style={{borderRadius:'0'}}>
      {/* {console.log(objectData, "objectData")} */}
      {loaderState ?
        <Loader />
        : null}
        
      {customLoaderState ?
        <CustomPopup actionHandler={customPopupActionhandler} message={msg} />
        : null}
      <PiePage
        totalPage={5}
        currentPage={1}
        heading={'Submit Applicant Detail'}
      />
      <div className='row' style={{marginBottom:'12px'}}>
        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
          <InputField
            label="Applicant Name"
            variant="outlined"
            value={objectData.name}
            name="name"
            id="name"
            type="text"
            onChange={e => inputChange(e, 'name')}
            size="small"
            required={true}
          />
          <div id="nameHelp" className="form-text text-danger">{message.field === 'name' ? message.msg : ""}</div>
        </div>
        {window.location.href.includes('/admin') ?
          <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
            <InputField
              label="Alias Name"
              variant="outlined"
              value={objectData.aliasName}
              name="aliasName"
              id="aliasName"
              type="text"
              onChange={e => inputChange(e, 'aliasName')}
              size="small"
            />

          </div> : ""}
        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
          <InputField
            label="Email Id"
            variant="outlined"
            value={objectData.emailId}
            name="emailId"
            id="emailId"
            type="email"
            onChange={e => inputChange(e, 'emailId')}
            size="small"
            required={true}
            className='lowercase'

          />
          <div id="emailIdHelp" className="form-text text-danger">{message.field === 'emailId' ? message.msg : ""}</div>
        </div>
        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
          <InputField
            label="Mobile No"
            variant="outlined"
            value={objectData.mobileNo}
            name="mobileNo"
            id="mobileNo"
            type="number"
            onChange={e => inputChange(e, 'mobileNo')}
            size="small"
            required={true}
          />
          <div id="mobileNoHelp" className="form-text text-danger">{message.field === 'mobileNo' ? message.msg : ""}</div>
        </div>
        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
          {console.log("data picker", objectData.dob)}
          {/* <DatePicker
                        label="Date of Birth"
                        value={objectData.dob ? objectData.dob : ""}
                        name="dob"
                        size="small"
                        onChange={e => inputChange(e, 'dob')}

                    /> */}
          {/* <TextField
            value={objectData.dob ? objectData.dob : ""}
            style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}
            label="Date of Birth"
            name="dob"
            size="small"
            onChange={(e) => inputChange(e, 'dob')} /> */}

<InputField
            label="Date of Birth"
            placeholder=""
            variant="outlined"
            value={objectData.dob ? objectData.dob : moment(new Date).format("YYYY-MM-DD")}
           name="dob"
            // id="name"
            type="date"
            onChange={e => inputChange(e, 'dob')}
            size="small"
            // required={true}
          />


          <div id="dobHelp" className="form-text text-danger">{message.field === 'dob' ? message.msg : ""}</div>
        </div>
        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
          <InputField
            label="PAN Number"
            variant="outlined"
            value={objectData.panNo}
            name="panNo"
            id="panNo"
            type="text"
            onChange={e => inputChange(e, 'panNo')}
            size="small"
          // required={true}
          />
          <div id="panNoHelp" className="form-text text-danger">{message.field === 'panNo' ? message.msg : ""}</div>
        </div>
        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
          <InputField
            label="Name on PAN"
            variant="outlined"
            value={objectData.nameOnPan}
            name="nameOnPan"
            id="nameOnPan"
            type="text"
            onChange={e => inputChange(e, 'nameOnPan')}
            size="small"
            readOnly={true}
          // required={true}
          />
          <div id="nameOnPanHelp" className="form-text text-danger">{message.field === 'nameOnPan' ? message.msg : ""}</div>
        </div>
        <div className=' col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
          <InputField
            label="Aadhaar Number"
            variant="outlined"
            value={objectData.aadharNo}
            name="aadharNo"
            id="aadharNo"
            type="number"
            onChange={e => inputChange(e, 'aadharNo')}
            size="small"
          // required={true}
          />
          <div id="aadharNoHelp" className="form-text text-danger">{message.field === 'aadharNo' ? message.msg : ""}</div>
        </div>
        {/* <div className='mb-3 col-sm-6 col-xs-12'>
                    <InputField
                        label="Name On Aadhaar"
                        variant="outlined"
                        value={objectData.nameOnAadhaar}
                        name="nameOnAadhaar"
                        id="nameOnAadhaar"
                        type="text"
                        onChange={e => inputChange(e, 'nameOnAadhaar')}
                        size="small"
                        required={true}
                    />
                    <div id="nameOnAadhaarHelp" className="form-text text-danger">{message.field === 'nameOnAadhaar' ? message.msg : ""}</div>
                </div> */}
        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
          <SelectField
            label={'Loan Segment'}
            onChange={e => inputChange(e, 'loanSegment')}
            id="loanSegment"
            value={objectData.loanSegment}
            name="loanSegment"
            data={loanSegmentArr}
            size={'small'}
            required={true}
          />
          <div id="loanSegmentHelp" className="form-text text-danger">{message.field === 'loanSegment' ? message.msg : ""}</div>
        </div>
        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
          <SelectField
            label={'Loan Type'}
            onChange={e => inputChange(e, 'loanType')}
            id="loanType"
            value={objectData.loanType}
            name="loanType"
            data={objectData.loanSegment === 'secured' ? secureLoanTypeArr : objectData.loanSegment === 'unsecured' ? unsecureLoanTypeArr : []}
            size={'small'}
            required={true}
          />
          <div id="loanTypeHelp" className="form-text text-danger">{message.field === 'loanType' ? message.msg : ""}</div>
        </div>
        {objectData.loanType === 'other' ?
          <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
            <InputField
              label="Enter Loan Type"
              variant="outlined"
              value={objectData.enterloanType}
              name="enterloanType"
              id="enterloanType"
              type="text"
              onChange={e => inputChange(e, 'enterloanType')}
              size="small"
              required={true}
            />
            <div id="loanTypeHelp" className="form-text text-danger">{message.field === 'enterloanType' ? message.msg : ""}</div>

          </div>
          : ""}
        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
          <SelectField
            label={'Borrowing Type'}
            onChange={e => inputChange(e, 'borrowingType')}
            id="borrowingType"
            value={objectData.borrowingType}
            name="borrowingType"
            data={borrowingTypeArr}
            size={'small'}
            required={true}
          />
          <div id="borrowingTypeHelp" className="form-text text-danger">{message.field === 'borrowingType' ? message.msg : ""}</div>
        </div>
        <div className='col-sm-6 col-xs-12' style={{marginBottom:'12px'}}>
          <SelectField
            label={'Source Of Income'}
            onChange={e => inputChange(e, 'sourceOfIncome')}
            id="sourceOfIncome"
            value={objectData.sourceOfIncome}
            name="sourceOfIncome"
            data={employmentTypeArr}
            size={'small'}
            required={true}
          />
          <div id="employmentTypeHelp" className="form-text text-danger">{message.field === 'sourceOfIncome' ? message.msg : ""}</div>
        </div>
      </div>
      <div className=' row' style={{marginBottom:'12px'}}>
        <div className="form-text text-danger">{responseMsg}</div>
        <div className="col-12 text-center">
          {
            !window.location.href.includes('/external') ?
              <button className="cred-btn cancel-btn" onClick={e => saveHandler('close')} style={{fontSize:'16px'}}>Close</button>
              :
              <a href={WEBSITE}> <button type="button" className="cred-btn" style={{fontSize:'16px'}}>Close</button></a>
          }
          <button className="cred-btn" style={{fontSize:'16px'}} onClick={e => saveHandler('save')}>Save and Continue</button>
        </div>
      </div>
    </div>
  )
}

export default AddCommunityLeadPersonal;
